module.exports = __webpack_public_path__ + "img/About_Us_Cover.7b48fec7.png";